import Axios from 'axios'
import { getCookie } from 'utils/cookies'
import { sentryLog } from 'utils/sentryLogging'
import type { AdServerProperties } from 'entities/Config'

export interface EventsUrls {
  clickUrl?: string
  impressionUrl?: string
  viewUrl?: string
  placeUrl?: string
}

interface AdServerPlacement {
  divName: string
  adTypes: Array<number>
  tags?: Array<string>
}

const API_VERSION = 'v1'

const getAdServerEventsUrls = async (
  adServerProperties?: AdServerProperties
): Promise<EventsUrls> => {
  const asbidc = getCookie('asbidc')

  if (adServerProperties && asbidc && process.env.REACT_APP_AD_SERVER_API_URL) {
    const {
      decisionName,
      adType,
      viewEventId,
      placeEventId,
      tag,
    }: AdServerProperties = adServerProperties

    const placementData: AdServerPlacement = {
      divName: decisionName,
      adTypes: [adType],
    }

    if (tag) {
      placementData.tags = [tag]
    }

    try {
      const { data } = await Axios({
        method: 'POST',
        baseURL: `${process.env.REACT_APP_AD_SERVER_API_URL}/${API_VERSION}`,
        url: '/d',
        data: {
          user: { asbidc },
          placements: [placementData],
        },
      })

      const { decisions } = data

      return {
        clickUrl: decisions?.[decisionName]?.clickUrl,
        impressionUrl: decisions?.[decisionName]?.impressionUrl,
        viewUrl: decisions?.[decisionName]?.events?.find(
          (event: { id: number; url?: string }) => event.id === viewEventId
        )?.url,
        placeUrl: decisions?.[decisionName]?.events?.find(
          (event: { id: number; url?: string }) => event.id === placeEventId
        )?.url,
      }
    } catch (error) {
      sentryLog(error)
    }
  }

  return {}
}

export default getAdServerEventsUrls
